import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  color: ${props => props.theme.bodyColor};
  margin-top: 8px;
  font-size: 14px;
  line-height: 120%;
`;

const Label = styled.div`
  text-transform: uppercase;
  font-weight: ${props => props.theme.fontWeightHeavy};
  margin-right: 16px;
`;

const Value = styled.div`
  text-transform: capitalize;
`;

export default function Item({ label, value }) {
  return (
    <Container>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </Container>
  );
}

Item.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
